import React from 'react';

import { Urls } from 'js/src/client';
import Callout, { CALLOUT_TYPES } from 'js/src/components/common/ui/Callout';
import { UPGRADE_STATUS } from 'js/src/components/pricing/types';

export function UpgradeNode(props: {
    upgradeStatus: UPGRADE_STATUS | undefined;
    planName: string | undefined;
    retryUpgradeWithNewCard: VoidFunction;
}) {
    switch (props.upgradeStatus) {
        case UPGRADE_STATUS.SUCCESS:
            if (props.planName === 'Community') {
                // downgrade
                return (
                    <Callout
                        className="mt-l5-12"
                        msgType={CALLOUT_TYPES.INFO}
                        title="Plan change successful!"
                        text="You are now on the Free Plan"
                    />
                );
            } else {
                // upgrade
                return (
                    <Callout
                        className="mt-l5-12"
                        msgType={CALLOUT_TYPES.INFO}
                        title="Successfully upgraded!"
                        text={`You are now on ${props.planName}`}
                    />
                );
            }
        case UPGRADE_STATUS.CARD_DECLINED:
            return (
                <Callout
                    className="mt-l5-12"
                    msgType={CALLOUT_TYPES.ERROR}
                    title="Your card was declined."
                    ctaText="Try a different card"
                    onCtaClick={props.retryUpgradeWithNewCard}
                />
            );
        case UPGRADE_STATUS.TEAM_SIZE_ERROR:
            return (
                <Callout
                    className="mt-l5-12"
                    msgType={CALLOUT_TYPES.ERROR}
                    title="You're trying to decrease the number of users on your plan but you have too many active team members. Please first remove team members to reduce your team size."
                    ctaText="View team settings"
                    onCtaClick={() => {
                        window.location.href = Urls.TEAM_MANAGEMENT;
                    }}
                />
            );
        case UPGRADE_STATUS.PERMISSION_ERROR:
            return (
                <Callout
                    className="mt-l5-12"
                    msgType={CALLOUT_TYPES.ERROR}
                    title="Please contact your team administrator to make changes to your plan."
                />
            );
        case UPGRADE_STATUS.SCA_REQUIRED:
            return (
                <Callout
                    className="mt-l5-12"
                    msgType={CALLOUT_TYPES.ERROR}
                    title="Your bank requires additional authentication for this purchase. Once you approve it, we will upgrade your account automatically."
                    ctaText="Learn more"
                    onCtaClick={() =>
                        window.open(
                            'https://help.lumen5.com/en/article/strong-customer-authentication-to3xag/',
                            '_blank',
                        )
                    }
                />
            );
        case UPGRADE_STATUS.ADDON_BILLING_INTERVAL_MISMATCH:
            return (
                <Callout
                    className="mt-l5-12"
                    msgType={CALLOUT_TYPES.ERROR}
                    title="Add-on is on a different billing interval. Please contact support for assistance."
                />
            );
        case UPGRADE_STATUS.GENERIC_ERROR:
            return (
                <Callout
                    className="mt-l5-12"
                    msgType={CALLOUT_TYPES.ERROR}
                    title="There was an error processing your payment. Please try again."
                />
            );
        default:
            return null;
    }
}
